<template>
  <form @submit.prevent="submit" :class="errorClass">

    <div class="flex-col">
      <div class="flex-row">
        <rp-textinput
          v-model="resource.email"
          placeholder="email"
          :error="emailError"
          isRequired
          :disabled="disabled"
          @input="touch('email')" />

        <rp-textinput
          v-model="resource.patient_id"
          placeholder="patient id"
          :disabled="disabled"
          @input="touch('patient_id')" />
      </div>

      <div class="flex-row">
        <rp-select
          class="language"
          v-model="resource.locale"
          placeholder="Language spoken"
          @input="touch('locale')"
          :disabled="disabled"
          isRequired
          :error="localeError">
          <option v-for="locale in locales" :key="locale.id" :value="locale.id">
            {{locale.name}}
          </option>
        </rp-select>

        <rp-textinput
          v-model="resource.phone"
          v-on:input="clearEngagementType"
          placeholder="phone"
          :disabled="disabled"
          :error="phoneFormatError"
          @input="touch('phone')" />
      </div>

      <div class="flex-row">
        <div class="halfw" />
        <rp-radios class="radios"
          v-if="false"
          label="Send Questionnaires By"
          helper-text="The questionnaire links will be sent by this method"
          :flat="true"
          :disabled="disabled"
          :error="engagementTypeError">
          <rp-radio v-for="etype in engagementTypes"
            v-bind:key="etype.id"
            v-model="resource.engagement_type_id"
            name="radio"
            :bit= etype.id
            :label= etype.name
            :disabled="disabled" />
        </rp-radios>
      </div>

      <div class="flex-row">
        <rp-datepicker
          class="fullw"
          v-model="resource.dob"
          placeholder="Date of Birth"
          :yearFromOffset="-100"
          @input="touch('dob')"
          :disabled="disabled"
          :error="dobError" />

        <rp-select
          class="gender"
          v-model="resource.gender"
          placeholder="Gender"
          @input="touch('gender')"
          :disabled="disabled">
          <option v-for="gender in genders" :key="gender.value" :value="gender.value">
            {{gender.label}}
          </option>
        </rp-select>
      </div>

      <div class="flex-row cropped">
        <rp-checkbox
          class="fullw"
          v-model="resource.accept_terms"
          @input="touch('accept_terms')"
          isRequired
          :error="accept_termsError"
          label="I confirm that I have read the consent statement to the patient and received their oral consent"
        />

        <rp-select
          class="refraction"
          v-model="resource.target_refraction_id"
          placeholder="Target Refraction"
          :disabled="disabled">
          <option v-for="tr in targetRefractions" :key="tr.id" :value="tr.id">
            {{tr.value}}
          </option>
        </rp-select>
      </div>
    </div>

    <rp-button :disabled="isInvalid" type="primary">Continue to Pre-Op</rp-button>
  </form>
</template>

<script>
  import {validationMixin} from 'vuelidate'
  import {email, required, requiredIf, sameAs, helpers} from 'vuelidate/lib/validators'
  import {date} from '../../../api/validators'
  import {errorMessages} from '../../../api/error_messages'

  import form from '../../../mixins/form'

  import Button from '../../../components/ui/inputs/Button'
  import Password from '../../../components/ui/inputs/PasswordInput'
  import TextInput from '../../../components/ui/inputs/TextInput'
  import DatePicker from '../../../components/ui/inputs/DatePicker'
  import Select from '../../../components/ui/inputs/StyledSelect'
  import Checkbox from '../../../components/ui/inputs/Checkbox'
  import Radio from '../../../components/ui/inputs/Radio'
  import Radios from '../../../components/ui/inputs/Radios'

  const phoneRegex = /^\+[1-9]\d{6,14}$/
  const phoneValidator = helpers.regex('phone', phoneRegex)

  export default {
    name: 'PatientForm',
    mixins: [validationMixin, form],

    components: {
      'rp-button': Button,
      'rp-password': Password,
      'rp-textinput': TextInput,
      'rp-datepicker': DatePicker,
      'rp-select': Select,
      'rp-checkbox': Checkbox,
      'rp-radio': Radio,
      'rp-radios': Radios
    },

    props: {
      genders: Array,
      locales: Array,
      engagementTypes: Array,
      targetRefractions: Array,
      disabled: Boolean,
    },

    methods: {
      clearEngagementType(textVal) {
        if (textVal == '') {
          this.resource.engagement_type_id = null
        }
      },

      isPhoneEnabled() {
        return (this.resource.phone && this.resource.phone != '')
      }
    },

    computed: {
      ...errorMessages([
        'email',
        'locale',
        'dob',
        'accept_terms']),

        phoneFormatError() {
          if (!this.resource.phone || this.resource.phone == '') {
            return ''
          } else if (this.resource.phone) {
            return (phoneRegex.test(this.resource.phone)) ? '' : 
              'Phone number must be in international format e.g. +441234567890'
          }
        },

        engagementTypeError() {
          return (this.resource.engagement_type_id == null) ? 'This field is required' : ''
        }
    },

    validations: {
      resource: {
        email: {required, email},
        locale: {required},
        patient_id: {required:false},
        first_name: {required:false},
        last_name: {required:false},
        gender: {required:false},
        yob: {required:false},
        dob: {required:false, date},
        phone: {required:false, phoneValidator},
        engagement_type_id: {required: requiredIf(function(n) {
          return false //this.isPhoneEnabled()
        })},
        accept_terms: {terms: sameAs( () => true )}
      }
    }
  }
</script>

<style lang="sass" scoped>
  .flex-col
    display: flex
    flex-direction: column
  .flex-row
    display: flex
    flex-direction: row
    gap: 20px
  .halfw
    width: 50%
  .fullw
    width: 100%
  .cropped
    margin-top: -16px
</style>



// WEBPACK FOOTER //
// ../raypro_ui/src/components/ui/forms/Patient_v2.vue